import React, { useEffect } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import JsBarcode from 'jsbarcode';

export const BarcodeScanner = () => {
  useEffect(() => {
    const barcodeSuccessCallback = qrCodeMessage => {
      console.log('Barcode detected:', qrCodeMessage);
      // Aqui, você pode lidar com o valor do código de barras como desejar.
      // Por exemplo, enviar para um servidor, exibir na tela, etc.
    };

    const barcodeErrorCallback = errorMessage => {
      console.error('Error while scanning barcode:', errorMessage);
    };

    const generateBarcode = value => {
      JsBarcode('#barcode', value, {
        format: 'CODE128',
        displayValue: true,
        width: 2, // Ajuste a largura das barras para garantir que o código de barras seja legível
        height: 100, // Ajuste a altura para garantir que o código de barras seja legível
      });
    };

    // Cria uma instância do leitor QRCode
    const barcodeScanner = new Html5QrcodeScanner(
      'barcodeReader', // ID do elemento onde o leitor será renderizado
      { fps: 10, qrbox: 500, aspectRatio: 3 },
      barcodeSuccessCallback,
      barcodeErrorCallback
    );

    // Configurações adicionais para garantir a leitura do código de barras completo
    barcodeScanner._setScanRegionRectangle = function(config) {
      const width = config.width;
      const height = config.height;
      const qrboxSize = config.qrboxSize;
      const top = (height - qrboxSize) / 2 - 50; // Ajuste a margem superior para garantir que o código de barras esteja no centro
      const right = (width - qrboxSize) / 2;
      const bottom = top + qrboxSize + 100; // Ajuste a margem inferior para garantir que o código de barras esteja no centro
      const left = right;

      barcodeScanner.domElement.querySelector(
        '.qrcode-scan-region'
      ).style.border = 'solid 1px rgba(0, 0, 0, 0.3)';
      barcodeScanner.domElement.querySelector(
        '.qrcode-scan-region'
      ).style.top = `${top}px`;
      barcodeScanner.domElement.querySelector(
        '.qrcode-scan-region'
      ).style.right = `${right}px`;
      barcodeScanner.domElement.querySelector(
        '.qrcode-scan-region'
      ).style.bottom = `${bottom}px`;
      barcodeScanner.domElement.querySelector(
        '.qrcode-scan-region'
      ).style.left = `${left}px`;
    };

    // Inicializa o leitor de código de barras
    barcodeScanner.render();

    // Quando o componente é desmontado, pare a leitura do código de barras
    return () => {
      barcodeScanner.stop();
    };
  }, []);

  return (
    <div>
      <h1>Leitor de Código de Barras</h1>
      <div id="barcodeReader" style={{ width: '100%', height: '300px' }}></div>
      {/* Aqui, vamos exibir o código de barras gerado */}
      <svg id="barcode" style={{ display: 'none' }}></svg>
    </div>
  );
};
